import React from "react";

/**
 * Composant de champ de formulaire réutilisable
 */
const ProfileFormField = ({
  label,
  value,
  isEditing,
  register,
  error,
  placeholder,
  isReadOnly = false,
  helperText,
}) => {
  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
      </label>
      {isEditing && !isReadOnly ? (
        <>
          <input
            type="text"
            {...register}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder={placeholder}
          />
          {error && (
            <p className="text-red-500 text-sm mt-1">{error.message}</p>
          )}
        </>
      ) : (
        <>
          <p className={`py-2 ${isReadOnly ? 'bg-gray-100 px-4 rounded-lg' : 'text-gray-800'}`}>
            {value || "-"}
          </p>
          {helperText && (
            <p className="text-xs text-gray-500 mt-1">{helperText}</p>
          )}
        </>
      )}
    </div>
  );
};

export default ProfileFormField;
